import React from 'react';
import { BrowserRouter, Redirect, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';
import connect from 'react-redux/es/connect/connect';

import RouteWithTitle from 'src/app/components/RouteWithTitle';
import LoginContainer from 'src/app/containers/Login/LoginContainer';
import ResetNewPasswordFormContainer from 'src/app/containers/Reset/ResetNewPasswordContainer';
import AccountFormContainer from 'src/app/containers/Registration/Account/AccountComponent';
import ConfirmAccountContainer from 'src/app/containers/Registration/ConfirmAccountContainer';
import CheckMailboxContainer from 'src/app/containers/Registration/CheckMailboxContainer';
import ResetEmailFormContainer from 'src/app/containers/Reset/ResetEmailComponent';
import ResetEmailSentContainer from 'src/app/containers/Reset/ResetEmailSentContainer';
import RegistrationTrackerContainer from 'src/app/containers/RegistrationTrackerContainer';
import ExperienceComponent from 'src/app/containers/Registration/Experience/ExperienceComponent';
import AuthorizationGuardContainer from 'src/app/containers/AuthorizationGuardContainer';
import { MAILBOX_STEP, LOGIN_REDIRECTION, EXPERIENCE_STEP } from 'src/app/redux/actions/registration/registration';


const RoutesContainer = ({ emailSent, registrationStep }) => (
  <BrowserRouter>
    <Switch>
      <RouteWithTitle
        title="Zaloguj się w koncie Pracuj.pl"
        exact
        path="/"
        render={ () =>
          <AuthorizationGuardContainer>
            <LoginContainer />
          </AuthorizationGuardContainer>
            }
      />

      <RouteWithTitle
        title="Przypomnij hasło w koncie Pracuj.pl"
        path="/przypomnij-haslo"
        render={ () =>
          <AuthorizationGuardContainer>
            { emailSent ? <ResetEmailSentContainer /> : <ResetEmailFormContainer /> }
          </AuthorizationGuardContainer>
          }
      />

      <RouteWithTitle
        title="Zmień hasło w koncie Pracuj.pl"
        path="/zmien-haslo"
        render={ () =>
          <AuthorizationGuardContainer>
            <ResetNewPasswordFormContainer/>
          </AuthorizationGuardContainer>
          }
      />

      <RouteWithTitle
        title="Potwierdź konto w Pracuj.pl"
        path="/potwierdz-konto"
        render={ () =>
          <AuthorizationGuardContainer>
            <ConfirmAccountContainer/>
          </AuthorizationGuardContainer>
        }
      />

      <RouteWithTitle title="Zarejestruj się w Pracuj.pl"
                      exact path="/zaloz-konto"
                      render={ ({ location }) =>
                        <AuthorizationGuardContainer>
                          {
                            {
                              [MAILBOX_STEP]: (<CheckMailboxContainer />),
                              [EXPERIENCE_STEP]: (<ExperienceComponent />),
                              [LOGIN_REDIRECTION]: (<Redirect to={ { pathname: '/', search: location.search } }/>)
                            }[registrationStep] || (<AccountFormContainer />)
                          }
                        </AuthorizationGuardContainer>
                      }
      />

      <RouteWithTitle title="Pracuj.pl - trwa przekierowanie"
                      exact
                      path="/przekierowanie"
                      component={ RegistrationTrackerContainer }
      />

      <Redirect from="*" to="/"/>
    </Switch>
  </BrowserRouter>
);

RoutesContainer.propTypes = {
  registrationStep: PropTypes.string.isRequired,
  emailSent: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
  emailSent: state.resetEmailSendReducer.emailSent,
  registrationStep: state.registrationReducer.step
});

export default connect(mapStateToProps)(RoutesContainer);
